import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05cb8300&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\progect\\guowai\\ex_express_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05cb8300')) {
      api.createRecord('05cb8300', component.options)
    } else {
      api.reload('05cb8300', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=05cb8300&", function () {
      api.rerender('05cb8300', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/sms-recharge/index.vue"
export default component.exports